import { extends as _extends, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState } from 'react';
import { useTheme } from '@emotion/react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import { map, truncate } from 'lodash-es';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { StyledMenu, StyledMenuTitle, StyledShownArea, StyledMenuItem, StyledDragHandlerBarArea } from './DraggableList.styles.js';
import DraggableListItem from './DraggableListItem.js';
import Button from '../../Button/Button.js';
import IconButton from '../../Button/IconButton.js';
import { COLOR, VARIANT } from '../../constants/common.js';
function DraggableList(_ref) {
  let {
    items,
    onDragEnd,
    onShowOrHide,
    onReset,
    onRemoveHeader,
    customTableTop
  } = _ref;
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const handleShow = (event, item) => {
    event.stopPropagation();
    onShowOrHide(_objectSpread2(_objectSpread2({}, item), {}, {
      show: true
    }));
  };
  const handleOpenCustomize = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseCustomize = () => {
    setAnchorEl(null);
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      paddingBottom: '8px',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center'
    }
  }, customTableTop, /*#__PURE__*/React__default.createElement(Box, {
    onClick: handleOpenCustomize,
    width: "fit-content",
    p: "10px",
    borderRadius: "4px",
    display: "flex",
    sx: {
      marginLeft: '4px',
      cursor: 'pointer',
      border: anchorEl ? '1px solid #7B61FF' : '1px solid white',
      color: anchorEl ? '#7B61FF' : '#555',
      bgcolor: anchorEl ? '#FAF6FF' : 'white'
    }
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "meta-crm-icon-ic_customize font-size-16"
  })), /*#__PURE__*/React__default.createElement(StyledMenu, {
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: handleCloseCustomize,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    alignItems: "center",
    padding: "15px 18px",
    justifyContent: "space-between"
  }, /*#__PURE__*/React__default.createElement(StyledMenuTitle, null, "Customize Columns"), /*#__PURE__*/React__default.createElement(Button, {
    color: COLOR.SECONDARY,
    variant: VARIANT.TEXT,
    onClick: onReset,
    sx: {
      padding: 0,
      minWidth: 'unset'
    }
  }, "Reset")), /*#__PURE__*/React__default.createElement(StyledShownArea, null, /*#__PURE__*/React__default.createElement(MenuItem, {
    disabled: true,
    className: "sub-title"
  }, "Shown"), /*#__PURE__*/React__default.createElement(DragDropContext, {
    onDragEnd: onDragEnd
  }, /*#__PURE__*/React__default.createElement(Droppable, {
    droppableId: "droppable-list"
  }, provided => /*#__PURE__*/React__default.createElement("div", _extends({
    ref: provided.innerRef
  }, provided.droppableProps), map(items, (item, index) => {
    if (!item.show) {
      return null;
    }
    return /*#__PURE__*/React__default.createElement(DraggableListItem, {
      item: item,
      index: index,
      key: item.id,
      onShowOrHide: onShowOrHide
    });
  }), provided.placeholder)))), /*#__PURE__*/React__default.createElement(MenuItem, {
    disabled: true,
    className: "sub-title"
  }, "Hidden"), map(items, (item, index) => {
    if (item.show) {
      return null;
    }
    return /*#__PURE__*/React__default.createElement(StyledMenuItem, {
      key: item.id
    }, /*#__PURE__*/React__default.createElement(StyledDragHandlerBarArea, null), truncate(item.title, {
      length: 20
    }), /*#__PURE__*/React__default.createElement(Box, {
      display: "flex",
      marginLeft: "auto",
      alignItems: "center"
    }, /*#__PURE__*/React__default.createElement(IconButton, {
      size: 14,
      onClick: event => handleShow(event, item),
      color: theme.customColors.grey[800]
    }, /*#__PURE__*/React__default.createElement("i", {
      className: "meta-crm-icon-ic_preview font-size-12"
    })), onRemoveHeader && /*#__PURE__*/React__default.createElement(IconButton, {
      sx: {
        marginLeft: '12px'
      },
      onClick: event => onRemoveHeader(event, item),
      size: 14,
      color: theme.customColors.grey[800]
    }, /*#__PURE__*/React__default.createElement("i", {
      className: "meta-crm-icon-ic_trash font-size-16"
    }))));
  })));
}
DraggableList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})),
  onDragEnd: PropTypes.func,
  onShowOrHide: PropTypes.func,
  onReset: PropTypes.func,
  onRemoveHeader: PropTypes.func,
  customTableTop: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.node])
};
DraggableList.defaultProps = {
  items: [],
  onReset: null,
  onShowOrHide: null,
  onDragEnd: null,
  onRemoveHeader: null,
  customTableTop: null
};
var DraggableList$1 = /*#__PURE__*/React__default.memo(DraggableList);
export { DraggableList$1 as default };